export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";